import { setPercentage } from "store/features/enlarge/actions";
import { useAppSelector, useAppDispatch } from "store/store";
import { enlargeSelector } from "store/features/enlarge/selectors/enlargeSelector";
import { EnlargeState } from "store/features/enlarge/types";

export const usePercentage = () => {
    const {
        resizeSettings: {
            byPercentage: { percentage },
        },
        image,
    } = useAppSelector(enlargeSelector, equalityFn);
    const dispatch = useAppDispatch();

    const handleChange = (value: number) => dispatch(setPercentage(value));

    return {
        percentage,
        handleChange,
        image,
    };
};

const equalityFn = (left: EnlargeState, right: EnlargeState) => {
    if (
        left.resizeSettings.byPercentage.percentage !== right.resizeSettings.byPercentage.percentage ||
        left.image.original.height !== right.image.original.height
    )
        return false;

    return true;
};
